import { coreApi } from '../utils/axios';

const RESOURCE_ROOT = '/whitelabel_applications';

export const checkIsFlagAllowed = async function checkIsFlagAllowed({ whiteLabelAppId, flag }) {
  if (!whiteLabelAppId || !flag) {
    throw new Error('Invalid arguments');
  }

  const queryParams = new URLSearchParams({ flag }).toString();

  const response = await coreApi.get(`${RESOURCE_ROOT}/${whiteLabelAppId}/is-flag-allowed?${queryParams}`);
  return response.data.isAllowed;
};
